import React from 'react';

export default class Page1 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="innovativeimg">
                                            <img alt=""
                                                 src={require('@images/How to build and maintain trust.png')}/>
                                        </div>

                                        <div className="ilead-contentarea">

                                            <div className="circle_title"><img
                                                src={require('@images/browndot.jpg')}
                                                alt=""/>isn't it interesting?</div>
                                            <p>It is not easy to trust other people. That’s not opinion, but
                                                fact.</p>
                                            <div className="border_subtitle">Do you trust me?</div>
                                            <p>We are, according to evolutionary psychologists, hard-wired to
                                                detect risk. Over the many hundreds of thousands of years of our
                                                evolution, we have maintained some of the core instincts that
                                                would have alerted us to threat and danger when roaming the
                                                savannah plains. Indeed, we are almost six times more sensitive
                                                to threatening stimuli or situations than to ‘safe’ and
                                                non-threatening stimuli. So does this mean that we can spot
                                                threats, lies or even frauds easily?</p>
                                            <p>How good are we at knowing who to trust and when to trust
                                                them?</p>

                                            <div className="lightgreencontentbg keyquestionpad">
                                                <div className="border_subtitle">Truth is in the eye of the
                                                    beholder
                                                </div>
                                                <p>There are different types of trust present in our everyday
                                                    relationships. For example, there is emotional trust (do I
                                                    feel that this person shares my values, principles, beliefs
                                                    and that they will be on my wavelength?) and cognitive trust
                                                    (is this person factually credible and do I believe what
                                                    this person says?).</p>

                                                <p>Our trust mechanisms may not be as strong or as reliable as
                                                    we think. There has been a lot of research examining the
                                                    different behaviours between liars and those telling the
                                                    truth.<a className="superscripttext"
                                                             href="further_info.php?course=300"><sup>1</sup></a> A
                                                    key difference is in the language used – and in particular,
                                                    the level of detail provided when naturally telling the
                                                    truth.</p>
                                                <p>It seems, not surprisingly, that people don’t like
                                                    elaborating on facts when they are fabricating a story. As a
                                                    result, those who lie will typically use fewer words and
                                                    provide less detail in their descriptions. So whilst most of
                                                    us might typically look into the eyes of another person to
                                                    determine their trustworthiness, perhaps closing our eyes
                                                    and listening more carefully might be of more value.</p>

                                            </div>

                                            <div className="right-btn"><div
                                                onClick={this.props.handleChangePage('Page2')}
                                                className="button-next-previous-done">Next &gt;&gt;</div></div>

                                        </div>


                                    </div>


                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    ;
    }
    }